"use client";
 
import Logout from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import {
  AppBar,
  Avatar,
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import LockOutlineIcon from '@mui/icons-material/LockOutline';
import Link from "next/link";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/slice/auth/authSlice";
export default function Topbar({ onMenuClick, onDesktopMenuClick, desktopOpen }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch()
  const loggedUser = useSelector((state) => state?.auth?.user);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    dispatch(logout())
    localStorage.removeItem("token")
  }

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          bgcolor: "#F8FAFC",
          borderBottom: "1px solid #E5E7EB",
          boxShadow: 2,
        }}
      >
        <Toolbar>
          {/* Hamburger (left) */}
          <IconButton onClick={onMenuClick} sx={{ display: { md: "none" } }}>
            <MenuIcon />
          </IconButton>
          {/* //Desktop toggle button */}
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              position: "fixed",
              top: 16,
              left: desktopOpen ? 260 : 72,
              transition: "left 0.3s ease",
              zIndex: 1300
            }}
          >
            <IconButton onClick={onDesktopMenuClick}>
              <MenuIcon sx={{ fontSize: 34 }} />
            </IconButton>
          </Box>

          {/* FLEX SPACER */}
          <Box sx={{ flexGrow: 1 }} />

          {/* Avatar (right, always) */}
          <Box sx={{ justifyContent: "end", display: "flex", alignItems: "center", gap: 2, color: "#1D4ED8" }}>
            {/* <Link href="/login" style={{ textDecoration: "none", color: "inherit" }}>Sign In</Link> */}
            <Typography color="#242222" fontSize={16} fontWeight={600}>
              {loggedUser?.username}
            </Typography>
            {
              loggedUser?.profile_image ?
                <Box>
                  <img onClick={handleClick} src={loggedUser?.profile_image} alt="" className="w-10 h-10 cursor-pointer bg-black border border-[#ccc] rounded-full" />
                </Box> :
                <Avatar
                  sx={{ width: 32, height: 32, cursor: "pointer" }}
                  onClick={handleClick}
                />
            }


            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              slotProps={{
                paper: {
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "&::before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0,
                    },
                  },
                },
              }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              {/* Profile */}
              <MenuItem
                component={Link}
                href="/my-profile"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              > 
                <PermIdentityIcon/>
                Profile
              </MenuItem>
              <MenuItem
                component={Link}
                href="/change-password"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <LockOutlineIcon/>
                Change Password
              </MenuItem>

              {/* Settings */}
              {/* <MenuItem
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <Settings fontSize="small" />
              Settings
            </MenuItem> */}

              <Divider />

              {/* Logout */}
              <MenuItem
                component={Link}
                href="/login"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.5,
                  color: "error.main",
                }}
                onClick={handleLogout}
              >
                <Logout fontSize="small" />
                Logout
              </MenuItem>
            </Menu>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  );
}
